import z from "./index.es267.js";
import t from "./index.es144.js";
import x from "./index.es155.js";
import ee from "./index.es358.js";
import { trackStream as K } from "./index.es359.js";
import te from "./index.es158.js";
import { progressEventDecorator as M, progressEventReducer as W, asyncDecorator as _ } from "./index.es356.js";
import re from "./index.es357.js";
import oe from "./index.es354.js";
const G = 64 * 1024, { isFunction: C } = t, ne = (({ Request: o, Response: n }) => ({
  Request: o,
  Response: n
}))(t.global), {
  ReadableStream: H,
  TextEncoder: I
} = t.global, J = (o, ...n) => {
  try {
    return !!o(...n);
  } catch {
    return !1;
  }
}, se = (o) => {
  o = t.merge.call({
    skipUndefined: !0
  }, ne, o);
  const { fetch: n, Request: a, Response: w } = o, h = n ? C(n) : typeof fetch == "function", l = C(a), B = C(w);
  if (!h)
    return !1;
  const y = h && C(H), b = h && (typeof I == "function" ? /* @__PURE__ */ ((e) => (r) => e.encode(r))(new I()) : async (e) => new Uint8Array(await new a(e).arrayBuffer())), d = l && y && J(() => {
    let e = !1;
    const r = new a(z.origin, {
      body: new H(),
      method: "POST",
      get duplex() {
        return e = !0, "half";
      }
    }).headers.has("Content-Type");
    return e && !r;
  }), m = B && y && J(() => t.isReadableStream(new w("").body)), S = {
    stream: m && ((e) => e.body)
  };
  h && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !S[e] && (S[e] = (r, R) => {
      let i = r && r[e];
      if (i)
        return i.call(r);
      throw new x(`Response type '${e}' is not supported`, x.ERR_NOT_SUPPORT, R);
    });
  });
  const Q = async (e) => {
    if (e == null)
      return 0;
    if (t.isBlob(e))
      return e.size;
    if (t.isSpecCompliantForm(e))
      return (await new a(z.origin, {
        method: "POST",
        body: e
      }).arrayBuffer()).byteLength;
    if (t.isArrayBufferView(e) || t.isArrayBuffer(e))
      return e.byteLength;
    if (t.isURLSearchParams(e) && (e = e + ""), t.isString(e))
      return (await b(e)).byteLength;
  }, V = async (e, r) => t.toFiniteNumber(e.getContentLength()) ?? Q(r);
  return async (e) => {
    let {
      url: r,
      method: R,
      data: i,
      signal: X,
      cancelToken: N,
      timeout: Y,
      onDownloadProgress: F,
      onUploadProgress: U,
      responseType: c,
      headers: L,
      withCredentials: E = "same-origin",
      fetchOptions: q
    } = re(e), v = n || fetch;
    c = c ? (c + "").toLowerCase() : "text";
    let P = ee([X, N && N.toAbortSignal()], Y), T = null;
    const p = P && P.unsubscribe && (() => {
      P.unsubscribe();
    });
    let D;
    try {
      if (U && d && R !== "get" && R !== "head" && (D = await V(L, i)) !== 0) {
        let u = new a(r, {
          method: "POST",
          body: i,
          duplex: "half"
        }), g;
        if (t.isFormData(i) && (g = u.headers.get("content-type")) && L.setContentType(g), u.body) {
          const [$, O] = M(
            D,
            W(_(U))
          );
          i = K(u.body, G, $, O);
        }
      }
      t.isString(E) || (E = E ? "include" : "omit");
      const s = l && "credentials" in a.prototype, k = {
        ...q,
        signal: P,
        method: R.toUpperCase(),
        headers: L.normalize().toJSON(),
        body: i,
        duplex: "half",
        credentials: s ? E : void 0
      };
      T = l && new a(r, k);
      let f = await (l ? v(T, q) : v(r, k));
      const A = m && (c === "stream" || c === "response");
      if (m && (F || A && p)) {
        const u = {};
        ["status", "statusText", "headers"].forEach((j) => {
          u[j] = f[j];
        });
        const g = t.toFiniteNumber(f.headers.get("content-length")), [$, O] = F && M(
          g,
          W(_(F), !0)
        ) || [];
        f = new w(
          K(f.body, G, $, () => {
            O && O(), p && p();
          }),
          u
        );
      }
      c = c || "text";
      let Z = await S[t.findKey(S, c) || "text"](f, e);
      return !A && p && p(), await new Promise((u, g) => {
        oe(u, g, {
          data: Z,
          headers: te.from(f.headers),
          status: f.status,
          statusText: f.statusText,
          config: e,
          request: T
        });
      });
    } catch (s) {
      throw p && p(), s && s.name === "TypeError" && /Load failed|fetch/i.test(s.message) ? Object.assign(
        new x("Network Error", x.ERR_NETWORK, e, T),
        {
          cause: s.cause || s
        }
      ) : x.from(s, s && s.code, e, T);
    }
  };
}, ae = /* @__PURE__ */ new Map(), ie = (o) => {
  let n = o ? o.env : {};
  const { fetch: a, Request: w, Response: h } = n, l = [
    w,
    h,
    a
  ];
  let B = l.length, y = B, b, d, m = ae;
  for (; y--; )
    b = l[y], d = m.get(b), d === void 0 && m.set(b, d = y ? /* @__PURE__ */ new Map() : se(n)), m = d;
  return d;
};
ie();
export {
  ie as getFetch
};
//# sourceMappingURL=index.es271.js.map
